export default __webpack_public_path__ + "static/media/portfolio_v1.c08de1af.jpg";